<template>
    <SvgIcon
        width="307px"
        height="56px"
        classes="w-full"
        icon="authorize-info-icon"
    />
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "AuthorizeInfoIcon",
    components: { SvgIcon }
};
</script>
